import React from "react";
import TermsAndServices from "../components/Policy Pages/TermsAndServices";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import Banner from "../components/Banner";

function TermsServicesPage() {
  return (
    <>
      <Banner />

      <section className="hidden lg:block">
        <Navbar />
        <Warning />
      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      <TermsAndServices />
      <Footer />
    </>
  );
}

export default TermsServicesPage;
